module.exports = "/assets/data/6f698a36f6464fa98112f01e6cd400bc-OX25.data.json";